import React from 'react';
import loadingImage from '../assets/loading.svg';

const LoadingAnim = () => (
    <div className="text-center mt-5">
        <img src={loadingImage} width="150" height="150" alt="Loading..." />
    </div>
);

export default LoadingAnim;

